import PaymentDataModeFirst from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentDataModeFirst";
import { connect } from "react-redux";
import {
	calculatePartialPaymentAmount,
	checkIfPaymentAlmaAvailable,
	checkIfPaymentPledg4xDisponible,
	getAllowedPaymentTypes,
	getBookingPaymentMode,
	getBookingPaymentType,
	getEcheancierCasino,
	getPaymentModes,
	getSupportedPaymentTypes,
} from "app/pages/Booking/Payment/paymentSelector";
import {
	getQuoteTotalWithDelta,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import { bindActionCreators } from "redux";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";

import { FormattedMessage } from "react-intl";
import { FRANCE_DOM_COUNTRIES } from "app/constants";
import { isOperatorMode } from "app/pages/Auth/authSelectors";
import get from "lodash/get";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";
import {
	getOnlyNonApplicableCreditNotes,
	getOrderedUnusableCreditNotes,
	getOrderedUsableCreditNotes,
	getUsableCreditNotesTotal,
} from "app/pages/Account/MyCoupons/couponSelector";

const mapStateToProps = (state, ownProps) => {
	const total = getQuoteTotalWithDelta(state);

	let payment4XForbiddenCause;

	if (total < state.payment?.payment4x?.minAmount) {
		payment4XForbiddenCause = (
			<FormattedMessage
				id="error.payment.external.min.error"
				values={{ minAmount: state.payment?.payment4x?.minAmount }}
			/>
		);
	} else if (total > state.payment?.payment4x?.maxAmount) {
		payment4XForbiddenCause = (
			<FormattedMessage
				id="error.payment.external.max.error"
				values={{ maxAmount: state.payment?.payment4x?.maxAmount }}
			/>
		);
	} else if (
		FRANCE_DOM_COUNTRIES.indexOf(get(ownProps, "fields.contact.address.country.value")) === -1
	) {
		payment4XForbiddenCause = <FormattedMessage id="error.payment.external.country.error" />;
	}

	// TODO 4x rendre generique
	const isPaiementPledg4xAvailable = checkIfPaymentPledg4xDisponible(state);
	const isPaymentAlmaAvailable = checkIfPaymentAlmaAvailable(state);

	return {
		booking: state.booking,
		selectedPaymentMode: getBookingPaymentMode(state),
		selectedPaymentType: getBookingPaymentType(state),
		paymentTypes: getSupportedPaymentTypes(state),
		showAmountToPay: isOperatorMode(state),
		allowedPaymentTypes: getAllowedPaymentTypes(state),
		paymentModes: getPaymentModes(state),
		total: total,
		isPaiementPledg4xAvailable,
		isPaymentAlmaAvailable: isPaymentAlmaAvailable,
		mensualite2Fois: calculatePartialPaymentAmount(state),
		swissbilling: {
			forbiddenCause:
				total > state.payment?.paymentSwissbilling?.maxAmount ? (
					<FormattedMessage
						id="error.payment.swissbilling.max.error"
						values={{ maxAmount: state.payment?.paymentSwissbilling?.maxAmount }}
					/>
				) : (
					false
				),
			cgvURL: state.documents.payment.swissbillingCGV,
			maxAmount: state.payment?.paymentSwissbilling?.maxAmount,
		},
		casino: {
			forbiddenCause:
				!isPaiementPledg4xAvailable && !isPaymentAlmaAvailable && payment4XForbiddenCause,
			mensualiteCasino: getEcheancierCasino(state),
			maxAmount:
				!isPaiementPledg4xAvailable &&
				!isPaymentAlmaAvailable &&
				state.payment?.payment4x?.maxAmount,
		},
		isDepositEnabled: isDepositEnabled(state),
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		shop: state.shop,
		usableCreditNotes: getOrderedUsableCreditNotes(state),
		unusableCreditNotes: getOrderedUnusableCreditNotes(state),
		onlyNonApplicableCreditNotes: getOnlyNonApplicableCreditNotes(state),
		totalUsableCreditNote: getUsableCreditNotesTotal(state),
	};
};

const madDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			updateBooking,
		},
		dispatch
	);
};

export const PaymentDataModeFirstContainer = connect(
	mapStateToProps,
	madDispatchToProps
)(PaymentDataModeFirst);
